/**
 * @desc 根据TOB客户编号查询
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<defs.basics.BusinessCustomerDetailResponseDto>;
export function request(body: string, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/businessCustomer/getByCode`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
